var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCd = function SvgCd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 96H96l20.8-67.2L137.6 96h67.2l-54.4 41.6 20.8 67.2-54.4-41.6-54.4 41.6 20.8-67.2L28.8 96zM600 0L0 360v120h40l600-360V0h-40",
    fill: "#f7d618"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M640 0L0 384v96L640 96V0",
    fill: "#ce1021"
  })));
};
export default __webpack_public_path__ + "assets/665279f3253b5bb63933cc492d148f56.svg";
export { SvgCd as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cd.svg